module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-square.59b18f70.jpg";